/* eslint-disable */
import store from 'store2'

let setEmployeeInfoStore = function (employeeInfo) {
  store.local('employeeInfo', employeeInfo)
}

let getEmployeeInfoStore = function () {
  return store.local('employeeInfo')
}

let setTokenStore = function (token) {
  store.local('token', token)
}

let getTokenStore = function () {
  return store.local('token')
}

let getWechatId = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.wechatId
}

let getWorkCode = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.workCode
}

let getMobile = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.mobile
}

let getEmployeeName = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.employeeName
}

let getCompanyName = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.companyName
}

let getEmployeeId = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.employeeId
}

let getCompanyLogo = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.companyLogo
}

let getCompanyBack = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.companyBack
}

let getCheckLevel = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.checkLevel
}

let getCanTest = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.canTest
}

let getCompanyPath = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.companyPath
}

let getCompanyKey = function () {
  let employeeInfo = store.local('employeeInfo')

  return employeeInfo.companyKey
}

let getCompanyId = function () {
  let employeeInfo = store.local('employeeInfo')
  return employeeInfo.companyId
}

let isEmpty = function (obj) {
  if(obj === undefined || obj === null || obj === "" || obj.length === 0){
    return true
  }
  return false
}

let getCommonHeaders = function() {
  let employeeInfo = getEmployeeInfoStore()
  return {
    'authorization': 'Bearer ' + getTokenStore(),
    'x-page-id': '9999',
    'x-pagination-size': 15,
    'x-plat-type': 'wechat',
    'x-wechat-id': employeeInfo ? employeeInfo.wechatId : undefined,
    'x-third-id': employeeInfo ? employeeInfo.thirdId : undefined,
    'x-company-key': employeeInfo ? employeeInfo.companyKey : undefined,
    'x-company-id': employeeInfo ? employeeInfo.companyId : undefined,
    'x-user-id': employeeInfo ? employeeInfo.userId : undefined,
    'x-user-role-id': employeeInfo ? employeeInfo.userRoleId : undefined,
  }
}

module.exports = {
  setEmployeeInfoStore,
  getEmployeeInfoStore,
  getWechatId,
  getWorkCode,
  getMobile,
  getEmployeeName,
  getCompanyName,
  getEmployeeId,
  getCompanyLogo,
  getCompanyBack,
  getCheckLevel,
  getCanTest,
  getCompanyPath,
  isEmpty,
  setTokenStore,
  getTokenStore,
  getCommonHeaders,
  getCompanyKey,
  getCompanyId
}



// WEBPACK FOOTER //
// ./src/components/common/common.js